import Vue from 'vue';
import ComponentSVG from '@components/Svg'; // svg组件

// register globally
Vue.component('t-svg', ComponentSVG);

const requireAll = requireContext => requireContext.keys().map(requireContext);
const req = (require as any).context('./icons', false, /\.svg$/);
requireAll(req);
